import { render } from "./SectionContact.vue?vue&type=template&id=8914d246&scoped=true"
import script from "./SectionContact.vue?vue&type=script&lang=js"
export * from "./SectionContact.vue?vue&type=script&lang=js"

import "./SectionContact.vue?vue&type=style&index=0&id=8914d246&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8914d246"]])

export default __exports__